import { useContext, useEffect, useState } from "react"
import { ToolContext } from "../../../core/context/ToolContext";
import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";
import moment from "moment";
import { GetRandomThreeResult } from "../toolUsage/global/Format";
// import moment from "moment";

// const tool_id =  process.env.REACT_APP_TID_BIZ;
// const global_id = process.env.REACT_APP_GLOBAL_ID;

export const RenderAPI = () => {
    const { tool_state, /*navigation_state*/ } = useContext(ToolContext)
    const { __SESSION, globalLoader, toolOwned, validateAccount, toolShuffle } = tool_state
    // const { myToolPzl } = navigation_state
    const __init = async() => {
        await globalLoader.set(true)

        let prms = __SESSION.data.uaccess[0].role_id === 0 ? {aid:__SESSION.data.ainfo.aid, platform:'business' } : {aid:__SESSION.data.ainfo.aid, platform:'business', ref:0, owner_id:__SESSION.data.uaccess[0].owner_id }
        let resTool = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/tools/owned`, prms)
        toolOwned.set(resTool)
         if (resTool.length > 3) { 
            const result = GetRandomThreeResult(resTool); 
            toolShuffle.set(result) 
        } 
        if (window.atob(__SESSION.data.ainfo.aid).split('_')[1] !== '0') {     
            let body = {
                action:"signin",
                aid: __SESSION.data.ainfo.aid,
                date: moment(new Date()).format('YYYY-MM-DD'),
                tool_id: process.env.REACT_APP_TID_BIZ, 
            }
           const signIn  = await rqx.post(`<<global>>/${env()}/trail/create`, body)
           console.log(signIn)
        }

        // PERSONALIZATION FOR BUSINESS
        // const tool_id = env()==='prod'?'332':'13'
        // const user_id = atob(__SESSION.data.ainfo.aid).split('_', 2)[1];
		// const prsnl = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/personalization/read`, {user_id:user_id, tool_id:tool_id, ref:'dashboard'})
        // if (prsnl && prsnl.length === 0) {
        //     myToolPzl.set(true)
        // }

        let compID = __SESSION.data.uaccess[0].company_id
        if (compID === null) {
            let bdy = { company_email: "", company_name: "", user_id: parseInt(window.atob(__SESSION.data.ainfo.aid).split('_').pop()) }
            let res_biz = await rqx.post(`<<biz>>/${env()}/general-maintenance/company/company-setup/createCI`, bdy)
            let uacc = [{...__SESSION.data.uaccess[0], company_id:res_biz.id}]
            __SESSION.set({...__SESSION.data, uaccess:uacc})
        }
        await globalLoader.set(false)
    }

    
    const [subscribe, setSubscribe] = useState(true)
    useEffect(() => {
        if (subscribe) {
            if (globalLoader.data) {
                __init()
            }
        }
        return () => setSubscribe(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateAccount.data])
    return (
        <></>
    )
}
     export const StartHereRead = async (qsp) => {
            try {
                let result = await rqx.get(`<<tool>>/${env()}/startHere/validatorBiz`, qsp);
                return result;
            } catch (error) {
            console.error(error);
            return 'error';
            }
        }

       